<div class="input-group app-colorpicker" role="input"
     [(colorPicker)]="scopedatavalue"
     [cpPosition]="options?.cpPosition || 'bottom'"
     [cpPositionOffset]="options?.cpPositionOffset || '12%'"
     [cpPositionRelativeToArrow]="options?.cpPositionRelativeToArrow ?? true"
     [cpPresetColors]="options?.presetColors ?? []"
     [cpWidth]="options?.cpWidth || 'auto'"
     [cpHeight]="'auto'"
     [cpAlphaChannel]="options?.cpAlphaChannel || 'disabled'"
     [cpOutputFormat]="'hex'"
     [cpOKButton]="options?.cpOKButton ?? false"
     [cpDisableInput]="options?.cpDisableInput ?? true"
     (colorPickerChange)="onChange($event)"
     (colorPickerClose)="handleBlur()"
     (colorPickerSelect)="handleSelect()">
  <input 
    placeholder="Eg:#ffffff" 
    class="form-control app-textbox" 
    [(ngModel)]="scopedatavalue" 
    (blur)="handleBlur()">
  <span class="input-group-addon colorpicker-container">
    <i class="colored-box" 
       [style.background]="(options?.previewColor || scopedatavalue) + ''" 
       [colorIcon]="options?.previewColor || scopedatavalue">
       &nbsp;
    </i>
    <div *ngIf="options?.opacity && options?.opacity !== '100%'" class="opacity-box" [style.opacity]="options?.opacity"></div>
  </span>
</div>